export const SET_EMAIL = (state, value) => {
  state.form.email = value
}

export const SET_EMITED = (state, value) => {
  state.form.emited = value
}

export const SET_READ = (state, value) => {
  state.form.read = value
}

export const SET_ACCEPTED = (state, value) => {
  state.form.accepted = value
}

export const SET_REFUSED = (state, value) => {
  state.form.refused = value
}

export const SET_EDITED = (state, value) => {
  state.form.edited = value
}

export const SET_IGNORED = (state, value) => {
  state.form.ignored = value
}
